import React, { useState } from "react";
import usePersonnelTable from "./usePersonnelTable";
import EditContactDialog from "./EditContactDialog";
import API_ROUTES from "../../../api-routes";
import { fetchPersonnel } from "./personnelSlice";
import { useDispatch } from "react-redux";
import apiService from "../../../services/service";
import { useParams } from "react-router-dom";
import PermissionGate from "~/components/PermissionGate";

const NoKeyPersonnel = ({
  showKeyPersonnel,
  personnelState,
  setPersonnelState,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    editVisible,
    setEditVisible,
    rowToEdit,
    setRowToEdit,
    showAddDialog,
    isAddMode,
    setSuccessMessage,
  } = usePersonnelTable();

  const [isLoading, setIsLoading] = useState(false);

  const handleAddNewContact = () => {
    showAddDialog();
  };

  const handleSave = async (formData) => {
    setIsLoading(true);
    const personnelData = {
      name: formData.name,
      last_name: formData.last_name,
      preferred_name: formData.preferred_name,
      other_name: formData.other_name,
      role: formData.role,
      email: formData.email,
      phone: formData.phone,
      phone_code: formData.phone_code,
      country: formData.country || null,
    };

    if (showKeyPersonnel) {
      setPersonnelState((prevState) => {
        const updatedPersonnelData = {
          ...personnelData,
          id: prevState.length,
        };

        return [...prevState, updatedPersonnelData];
      });

      setSuccessMessage("New Key Personnel has been added.");
    } else {
      const apiRoute = isAddMode ? API_ROUTES.ADD_PERSONNEL : "";

      try {
        const res = await apiService(apiRoute, "POST", {
          body: JSON.stringify(personnelData),
          replace: { id },
        });

        if (res.status) {
          dispatch(fetchPersonnel(id));
          setSuccessMessage("New Key Personnel has been added.");
        } else {
          setSuccessMessage("Failed to save contact details");
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error:", error);
      }
    }
    setEditVisible(false);
  };

  return (
    <>
      {showKeyPersonnel && (
        <div className="formgrid grid">
          <div className="field col-12">
            <p className="general-info">Key Personnel</p>
          </div>
        </div>
      )}
      <div className="formgrid grid flex justify-content-center align-item-center">
        <div className="no-key-container">
          <div>
            <svg
              width="136"
              height="137"
              viewBox="0 0 136 137"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_4853_57936)">
                <rect
                  x="12"
                  y="10.5"
                  width="112"
                  height="112"
                  rx="40"
                  fill="white"
                  shapeRendering="crispEdges"
                />
                <path
                  d="M48 34.5H84C88.375 34.5 92 38.125 92 42.5V90.5C92 95 88.375 98.5 84 98.5H48C43.5 98.5 40 95 40 90.5V42.5C40 38.125 43.5 34.5 48 34.5ZM62 70.5C56.375 70.5 52 75 52 80.5C52 81.625 52.875 82.5 54 82.5H78C79 82.5 80 81.625 80 80.5C80 75 75.5 70.5 70 70.5H62ZM58 58.5C58 61.375 59.5 64 62 65.5C64.375 66.875 67.5 66.875 70 65.5C72.375 64 74 61.375 74 58.5C74 55.75 72.375 53.125 70 51.625C67.5 50.25 64.375 50.25 62 51.625C59.5 53.125 58 55.75 58 58.5ZM100 44.5V52.5C100 53.625 99 54.5 98 54.5C96.875 54.5 96 53.625 96 52.5V44.5C96 43.5 96.875 42.5 98 42.5C99 42.5 100 43.5 100 44.5ZM98 58.5C99 58.5 100 59.5 100 60.5V68.5C100 69.625 99 70.5 98 70.5C96.875 70.5 96 69.625 96 68.5V60.5C96 59.5 96.875 58.5 98 58.5ZM100 76.5V84.5C100 85.625 99 86.5 98 86.5C96.875 86.5 96 85.625 96 84.5V76.5C96 75.5 96.875 74.5 98 74.5C99 74.5 100 75.5 100 76.5Z"
                  fill="#188A42"
                />
                <path
                  opacity="0.4"
                  d="M48 34.5H84C88.375 34.5 92 38.125 92 42.5V90.5C92 95 88.375 98.5 84 98.5H48C43.5 98.5 40 95 40 90.5V42.5C40 38.125 43.5 34.5 48 34.5ZM62 70.5C56.375 70.5 52 75 52 80.5C52 81.625 52.875 82.5 54 82.5H78C79 82.5 80 81.625 80 80.5C80 75 75.5 70.5 70 70.5H62ZM58 58.5C58 61.375 59.5 64 62 65.5C64.375 66.875 67.5 66.875 70 65.5C72.375 64 74 61.375 74 58.5C74 55.75 72.375 53.125 70 51.625C67.5 50.25 64.375 50.25 62 51.625C59.5 53.125 58 55.75 58 58.5ZM100 44.5V52.5C100 53.625 99 54.5 98 54.5C96.875 54.5 96 53.625 96 52.5V44.5C96 43.5 96.875 42.5 98 42.5C99 42.5 100 43.5 100 44.5ZM98 58.5C99 58.5 100 59.5 100 60.5V68.5C100 69.625 99 70.5 98 70.5C96.875 70.5 96 69.625 96 68.5V60.5C96 59.5 96.875 58.5 98 58.5ZM100 76.5V84.5C100 85.625 99 86.5 98 86.5C96.875 86.5 96 85.625 96 84.5V76.5C96 75.5 96.875 74.5 98 74.5C99 74.5 100 75.5 100 76.5Z"
                  fill="#188A42"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_4853_57936"
                  x="0"
                  y="0.5"
                  width="136"
                  height="136"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="2" />
                  <feGaussianBlur stdDeviation="6" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_4853_57936"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_4853_57936"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="no-key-align">
            <p className="no-key-personnel mb-2">No key Personnel registered</p>
            <PermissionGate
              resource="entity"
              action="modify"
              resourceAttr={{ entity_id: id }}
            >
              {showKeyPersonnel ? (
                <p className="no-key-personnel-para no-key-para">
                  Lets build a list of all the key people involved in this
                  entity. This will help us connect with the right people
                  whenever we need. Lets get started!
                </p>
              ) : (
                <p className="no-key-personnel-para">
                  Add your first contact to build your address book.
                </p>
              )}
            </PermissionGate>
          </div>
          <PermissionGate
            resource="entity"
            action="modify"
            resourceAttr={{ entity_id: id }}
          >
            <button className="add-new-contact" onClick={handleAddNewContact}>
              {" "}
              Add New Contact<span className="pi pi-user-plus mb-1 ml-2"></span>
            </button>
          </PermissionGate>
        </div>
      </div>

      <EditContactDialog
        visible={editVisible}
        onHide={() => setEditVisible(false)}
        rowToEdit={rowToEdit}
        setRowToEdit={setRowToEdit}
        onSave={handleSave}
        isAddMode={isAddMode}
        isLoading={isLoading}
      />
    </>
  );
};

export default NoKeyPersonnel;
